<template>
  <div>
    <div class="filter">
      <el-form
        :inline="true"
        @submit.native.prevent
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="80px"
        class="oneline"
        size="small"
      >
        <el-form-item :label="category == 1 ? '发往基地' : '库存基地'">
          <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
        </el-form-item>
        <el-form-item label="钻井" v-if="category == 2">
          <DrillWellSelect
            v-model="filter.drill_well_id"
            :clearable="true"
          ></DrillWellSelect>
        </el-form-item>
        <el-form-item label="配件分类">
          <ItemTemplateSelect
            v-model="filter.item_template_id"
            :category="category"
            :clearable="true"
          ></ItemTemplateSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="display: flex; justify-content: end">
      <file-button
        obj="not_used_item"
        :filter="queryData"
        exportBtnName="导出明细"
        :importButton="false"
      ></file-button>
    </div>
    <MyTable
      :items="items.list"
      :category="category"
      v-loading="loading"
    ></MyTable>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
  </div>
</template>

<script>
import { itemStatistics } from '@/service/getData'
import MyTable from './table'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    MyTable,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.is_not_used = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        base_id: '',
        drill_well_id: '',
        item_template_id: '',
        page: 1,
        size: 10,
        tab: 'not_used_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'not_used_data') {
        this.filter = filter
      }
    }
    this.getData()

    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.base_id = ''
        this.filter.drill_well_id = ''
        this.filter.item_template_id = ''
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await itemStatistics(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>